import { inject, observer } from 'mobx-react'
import { withRouter } from 'next/router'
import PropTypes from 'prop-types'
import TimelineSlider from '../components/TimelineSlider'

import { Component } from 'react'
import Footer from '../components/Footer'
import HeadlinersRoundGrid from '../components/HeadlinersRoundGrid'
import Layout from '../components/Layout'
import PostGrid from '../components/PostGrid'
import { DEFAULT_YEAR } from '../constants/history'
import { withTranslation, i18n } from '../i18n'
import { HistoryContent,HistoryText } from '../styles/newsStyles.ts'

@inject('store')
@observer
class History extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    i18n: PropTypes.instanceOf(Object).isRequired,
    store: PropTypes.instanceOf(Object).isRequired,
    router: PropTypes.instanceOf(Object).isRequired,
    currentLanguage: PropTypes.string.isRequired
  }

  static getInitialProps({ req }) {
    const currentLanguage = req ? req.language : i18n.language
    return {
      namespacesRequired: [
        'news',
        'common',
        'magazine',
        'auth',
        'reset-password',
        'contacts'
      ],
      currentLanguage
    }
  }

  componentDidMount() {
    this.getData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentLanguage !== prevProps.i18n.language) {
      this.getData()
    }
  }

  getData() {
    const {
      i18n: { language },
      store,
      router: { query }
    } = this.props
    store.loadHeadliners(language)
    store.loadHistoryYears({ language, query: '' })
    store.loadHistoryByYear({ language, query })
  }

  render() {
    const {
      t,
      i18n: { language },
      router: {
        query: { year }
      },
      store
    } = this.props

    let activeYear = +year



    const yearInfo = {
      year: store.historyByYear.year,
      guest_count: store.historyByYear.guest_count,
      artist_count: store.historyByYear.artist_count,
      scene_count: store.historyByYear.scene_count,
      extra_info: store.historyByYear.extra_info,
      info: store.historyByYear.info,
      video: {
        mp4: store.historyByYear.video.mp4,
        video_webm: store.historyByYear.video.video_webm,
      }
    }

    // историю показываем до 2025 года включительно
    const storeYears = store.historyYears.filter(
      (yearInfo) => yearInfo.year <= 2025
    ).map((yearInfo) => ({
      year: yearInfo.year,
      guest_count: yearInfo.guest_count,
      artist_count: yearInfo.artist_count,
      scene_count: yearInfo.scene_count,
      extra_info: yearInfo.extra_info
    })).sort((a, b) => a.year - b.year)

    const defaultYear = DEFAULT_YEAR

    activeYear =
      Number.isNaN(activeYear) || activeYear < 2015 || activeYear > defaultYear
        ? defaultYear
        : activeYear

    const showNews = activeYear === 2022

    const yearsInfo = storeYears.length !== 0 ? storeYears : [
      {
        year: 2015,
        guest_count: 70,
        scene_count: 43,
        artist_count: 1000
      },
      {
        year: 2016,
        guest_count: 120,
        scene_count: 76,
        artist_count: 1500
      },
      {
        year: 2017,
        guest_count: 150,
        scene_count: 100,
        artist_count: 1500
      },
      {
        year: 2018,
        guest_count: 200,
        scene_count: 103,
        artist_count: 2000
      },
      {
        year: 2019,
        guest_count: 300,
        scene_count: 80,
        artist_count: 2500
      },
      {
        year: 2020,
        guest_count: 170,
        scene_count: 50,
        artist_count: 700
      },
      {
        year: 2021,
        guest_count: 50,
        scene_count: 52,
        artist_count: 1300,
        extra_info: [t('covid-free')]
      },
      {
        year: 2022,
        guest_count: 360,
        scene_count: 103,
        artist_count: 3000
      },
      {
        year: 2023,
        guest_count: 370,
        scene_count: 102,
        artist_count: 3000
      },
      {
        year: 2024,
        guest_count: 380,
        scene_count: 106,
        artist_count: 2511
      },
      {
        year: 2025,
        guest_count: 450,
        scene_count: 120,
        artist_count: 3000
      }
    ]

    return (
      <Layout
        meta={{ title: t('common:PAGE_NEWS_TITLE') }}
        coverImageUrl="news-cover"
      >
        <TimelineSlider activeYear={activeYear} yearsInfo={yearsInfo} />

        <HistoryContent className="content">
          {yearInfo.video && (
            <div className="videoBlock" key={`{${activeYear}${yearInfo.video.mp4}${yearInfo.video.video_webm}`}>
              <video
                poster="" // don't delete this line!
                autoPlay
                muted
                loop
                playsInline
              >
                <source
                  src={yearInfo.video.video_webm ?? ''}
                  type="video/webm"
                />
                <source
                  src={yearInfo.video.mp4 ?? ''}
                  type="video/mp4"
                />
              </video>
            </div>
          )}
          <h1>{`Ural Music Night ${activeYear}`}</h1>
          {/* <p dangerouslySetInnerHTML={{ __html: t(`year${activeYear}`) }} /> */}
          <HistoryText  dangerouslySetInnerHTML={{ __html: yearInfo.info }} />
          {store.headliners.has(activeYear) && (
            <HeadlinersRoundGrid
              headliners={store.headliners.get(activeYear)}
              activeYear={activeYear}
            />
          )}
          {showNews && <PostGrid categories={['umn-news']} />}
        </HistoryContent>
        <Footer />
      </Layout>
    )
  }
}

const HistoryRouter = withRouter(History)
export default withTranslation([
  'news',
  'common',
  'magazine',
  'auth',
  'reset-password',
  'contacts'
])(HistoryRouter)
